import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AuthUser = {
  userId: string | number;
  email: string;
  roles: string[];
};
export type NusSession = {
  csrfToken: string;
} & (
  | { status: 'authenticated'; user: AuthUser }
  | { status: 'profile_required'; email: string }
);

type AuthState = {
  ready: boolean;
  session: NusSession | null;
  user: AuthUser | null;
};

const initialState: AuthState = { ready: false, session: null, user: null };

// Session details stay in the existing Redux store; provider tokens remain on the backend.
// Typed slice reference: https://redux.js.org/tutorials/typescript-quick-start
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuth: (_state, action: PayloadAction<AuthState>) => action.payload
  }
});

export const { setAuth } = authSlice.actions;
export default authSlice.reducer;
